<div class="header sm">
  @if (!embedService.embed && colorService.logoSrc) {
    <a class="logo" [routerLink]="colorService.companyId ? ['/companies', colorService.companyId] : ['']">
      <img [src]="colorService.logoSrc" alt="logo">
    </a>
  }
  <div class="links">
    @if (!embedService.embed) {
      <a [href]="seoService.website" target="_blank">
        <fa-icon [icon]="fontawesomeService.solid.externalLinkAlt"></fa-icon>
      </a>
    }
    <ng-select [items]="languages" [bindValue]="'value'" [bindLabel]="'name'"
      (change)="languageService.setLanguage($event.value)" [searchable]="false" [clearable]="false">
    </ng-select>
  </div>
</div>
<div class="header md">
  @if (!embedService.embed && colorService.logoSrc) {
    <a class="logo" [routerLink]="colorService.companyId ? ['/companies', colorService.companyId] : ['']">
      <img [src]="colorService.logoSrc" alt="logo">
    </a>
  }
  <div class="links">
    @if (!embedService.embed) {
      <a [href]="seoService.website" target="_blank">
        <fa-icon [icon]="fontawesomeService.solid.externalLinkAlt"></fa-icon>
        <span>{{'jobboard.static.header.website' | transloco}}</span>
      </a>
    }
    <ng-select [placeholder]="'jobboard.static.header.language' | transloco" [items]="languages" [bindValue]="'value'"
      [bindLabel]="'name'" (change)="languageService.setLanguage($event.value)" [searchable]="false" [clearable]="false">
    </ng-select>
  </div>
</div>
